<template>
  <div class="block-text" v-html="block.content.text" />
</template>

<script setup>
defineProps(['block'])
</script>

<style scoped>
.block-text :deep(p)  { font-size: 1.4rem; line-height: 1.65; margin-bottom: 1.4em; }
.block-text :deep(a)  { border-bottom: 1px solid var(--fg-50); }
.block-text :deep(strong) { font-weight: 500; }
</style>
